module.exports = __webpack_public_path__ + "fonts/Inter-100-cyrillic-ext22.251d36f.woff2";